import { gql } from './gql'

/**
 * Asks to be told when a sku comes back.
 *
 * The one thing a shopper can do with an out-of-stock product, and until now
 * the storefront offered them nothing: the card's add button is disabled and
 * the product page says "Sin stock" on a button that cannot be pressed. The
 * shopkeeper's alternative is to come back and check by hand.
 *
 * It answers with the `Product`, not with a receipt: there is no
 * "notification requested" flag anywhere in the schema, on the product or on
 * the session. So a page can confirm the request landed, and cannot know on a
 * later visit that it ever happened — see `useBackInStockNotice`, which is
 * where that limitation is handled rather than hidden.
 *
 * Only `sku` is selected. The mutation's job is the request, and re-reading
 * forty product fields to learn what the page already has on screen would be a
 * second copy of the product to keep consistent.
 */
export const NOTIFY_BACK_IN_STOCK = gql`
  mutation NotifyBackInStock($storefrontName: String!, $sessionUid: ID!, $sku: String!) {
    notifyBackInStock(storefrontName: $storefrontName, sessionUid: $sessionUid, sku: $sku) {
      sku
    }
  }
`
